// websocket.service.ts
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private socket: Socket;
  private notificacaoSubject = new Subject<any>();

  constructor() {
    this.socket = io('https://api.bonnapp.com.br');

    // Registra sempre que conectar (incluindo reconexões)
    this.socket.on('connect', () => {
      console.log('Socket conectado:', this.socket.id);
      this.registrarUsuario();
    });

    // Escuta notificações
    this.socket.on('notificacao', (notificacao: any) => {
      console.log('🔔 Nova notificação no WebSocketService:', notificacao);
      this.notificacaoSubject.next(notificacao);
    });
  }

  private registrarUsuario() {
    // Pega o userId do localStorage (ou sessionStorage)
    const userId =
      localStorage.getItem('userId') || sessionStorage.getItem('userId');

    if (userId) {
      this.socket.emit('register', { userId });
      console.log('Usuário registrado:', userId);
    }
  }

  // Observable para componentes se inscreverem
  onNotificacao(): Observable<any> {
    return this.notificacaoSubject.asObservable();
  }

  // Chame isso no login
  setUserId(userId: string) {
    localStorage.setItem('userId', userId);
    sessionStorage.setItem('userId', userId);
    this.registrarUsuario();
  }

  // Chame isso no logout
  clearUserId() {
    localStorage.removeItem('userId');
    sessionStorage.removeItem('userId');
    this.socket.disconnect();
  }
}
